module.exports = __webpack_public_path__ + "static/media/balloon-explode.bfab5fbc.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/balloon-explode.gif
// module id = 862
// module chunks = 0